import { render, staticRenderFns } from "./card-view.vue?vue&type=template&id=32ec8d16&scoped=true&"
import script from "./card-view.vue?vue&type=script&lang=ts&"
export * from "./card-view.vue?vue&type=script&lang=ts&"
import style0 from "./card-view.vue?vue&type=style&index=0&id=32ec8d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec8d16",
  null
  
)

export default component.exports